import React, {  useState } from 'react';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import RadioBox from '../../Radiox';
import BadgeIcon from '@mui/icons-material/Badge';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import DataType from '../../../Types/DataTablePiclist';
import { Box, Grid } from '@mui/material';
import SearchInput from '../../SearchInput';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import HouseboatIcon from '@mui/icons-material/Houseboat';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import SweetAlert from 'sweetalert2';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import BoyIcon from '@mui/icons-material/Boy';
import SelectOption from '../../SelectOption';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import SearchModal from '../../SearchModal';
import { interpretRegex } from '../../../Functions/Traitement/interpretRegex';


const Tab1 = (props: { etatG?: boolean, form?: any, Function?: Function }) => {

  const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const [RPiece, SetRPiece] = useState<RegExp>();
  const [MPiece, SetMPiece] = useState<string>();
  const [TPiece, SetTPiece] = useState<string>('');
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

  // USER TOKEN
  const authHeader = useAuthHeader();
    
  //Initialisation des parametres de recherche 
  let searchClient: ParamsPicklist = { CodeAgence: user.codage, Table: "view_AnyAllClient", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE',colfiltre:"TYPCLI",valfiltre:'P',Choix: 22 }
  let searchTitre: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'TITRESCLIENT', Choix: 22 }
  let searchSituationFamiliale: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "",colfiltre:'RUBRIQ',valfiltre:'SITFAM', Choix: 22 }
  //let searchGestionnaire: ParamsPicklist = { CodeAgence: 'GESTIONNAIRE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ',Choix: 22 }
   let searchGestionnaire: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'GESTIONNAIRE',Choix: 22 }

  let searchProspect: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'DEMARCHEUR', Choix: 22 }
  let searchClassRisque: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'CLASSERISQUE', Choix: 22 }
  let searchPays: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'PAYS', Choix: 22 }
  let searchActivite: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'ACTIVITE', Choix: 22 }
  let searchUniteInstitutionnel: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'UNITEINSTITUTIONNELLE', Choix: 22 }
  let searchRegimeMatrimonial: ParamsPicklist = { CodeAgence: "", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "",colfiltre:'RUBRIQ',valfiltre:'REGMAT', Choix: 22 }
  //
  let searchNiveauInstruction: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'NIVEAUETUDE', Choix: 22 }
  let searchEthnie: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'ETHNIE', Choix: 22 }
  let searchCateGo: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'PROFESSION', Choix: 22 }
  let searchZoneGeo: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'ZONEGEOGRAPHYQUE', Choix: 22 }
  let searchTypePiece: ParamsPicklist = { CodeAgence: "", Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: '',colfiltre:'RUBRIQ',valfiltre:'TYPPIECE', Choix: 22 };

  //vérification de la date de naissance qui doit etre supérieur à la date actuel
  const handleChangedatenais = (e: any) => {
    const DatteActuel = new Date(user.datjour).toISOString();

    if (e.target.value && e.target.value>= DatteActuel) {
      SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Supérieure à la Actuelle", icon: "error" });
      props.form.setFieldValue("DATNAI", '');
    }
  };

  //vérification de la date d'expiration de la CNI qui doit etre supérieur à la date actuel
  const handleChangedateexpirecni = (e: any) => {
    const DatteActuel = new Date(user.datjour).toISOString();

    if (e.target.value && e.target.value <= DatteActuel) {
      SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Inférieure à la Actuelle", icon: "error" });
      props.form.setFieldValue("DateDelcni", '');
    }
  };

  // Initialisation des parametres lorsqu'on le choisir

//    const handleChangeTypiece = (value: string) => {
//     props.form.setFieldsValue("numCNI", '');
    
//     let [, regexPart] = value.split('-', 2);
//     console.log(regexPart); // Regarde dans la console du navigateur (F12)
// }


  // const handleChangeTypiece = (value: string) => {
  //   props.form.setFieldsValue("numCNI", '');
  //   let regexPart = value.substring(value.indexOf('-') + 1);
  //   SetRPiece(new RegExp(regexPart));
  //   SetMPiece(interpretRegex(regexPart));

  // };


  const handleChangeTypiece = (value: string) => {

    props.form.setFieldsValue("numCNI", '');

    switch (value) {
      case 'P01':
        SetRPiece(/[0-9]{17}$/gmi);
        SetMPiece("la cni doit avoir 17 caractéres entiér ");
        SetTPiece('number');
        break;
      case 'P02':
        SetRPiece(/[A-Za-z0-9]{15}$/gmi);
        SetMPiece("la cni doit avoir 15 caractére");
        SetTPiece('text');
        break;
      case 'P03':
        SetRPiece(/[A-Za-z0-9]{18}$/gmi);
        SetMPiece("le récépissé de cni doit avoir 18 caractére");
        SetTPiece('text');
        break;
      case 'P04':
        SetRPiece(/[A-Za-z0-9]{9}$/gmi);
        SetMPiece("le passport doit avoir 9 caractére");
        SetTPiece('text');
        break;
    case 'P05':
        SetRPiece(/[A-Za-z0-9]/gmi);
        SetMPiece("le veuillez inserer le bon format");
        SetTPiece('text');
        break;
     case 'P06':
         SetRPiece(/[A-Za-z0-9]/gmi);
        SetMPiece("le veuillez inserer le bon format");
        SetTPiece('text');
        break;
      case 'P07':
         SetRPiece(/[A-Za-z0-9]/gmi);
        SetMPiece("le veuillez inserer le bon format");
        SetTPiece('text');
        break;
    }
  };


  
    const handleTypieceVerifie =()=>{

      const TYPEPIECE=props.form.getFieldValue("TYPEPIECE");
      const numCni = props.form.getFieldValue("numCNI");
 
      if(TYPEPIECE===undefined || TYPEPIECE===null){
          // props.form.setfielvalues("numCNI",'');
           SweetAlert.fire({ title: "saisie invalide", text: "Veuillez selectionner d'abord le d'dentification", icon: "error" });
            props.form.setFieldValue("numCNI", '');
      }
         
      // console.log(numCni, typPiece);
   }

  //information du client
  let informationclient = {
    SearchClient: {
      Titre: t("FormClientPhysique.informationclient.SearchClient.Titre"),
      label: t("FormClientPhysique.informationclient.SearchClient.label"),
      name: "NUMCLI", params: searchClient
    },
    SearchTitre: {
      Titre: t("FormClientPhysique.informationclient.SearchTitre.Titre"),
      label: t("FormClientPhysique.informationclient.SearchTitre.label"),
      name: "TITCLI", params: searchTitre
    },
    RadioSexe: {
      label: t("FormClientPhysique.informationclient.RadioSexe.label"),
      LibValue1: t("FormClientPhysique.informationclient.RadioSexe.LibValue1"),
      LibValue2: t("FormClientPhysique.informationclient.RadioSexe.LibValue2"),
      name: "CLSEXE"
    },
    RadioDirigeantE: {
      label: t("FormClientPhysique.informationclient.RadioDirigeantE.label"),
      LibValue1: t("FormClientPhysique.informationclient.RadioDirigeantE.LibValue1"),
      LibValue2: t("FormClientPhysique.informationclient.RadioDirigeantE.LibValue2"),
      name: "autreInfo"
    },
    InputDateNaissance: {
      label: t("FormClientPhysique.informationclient.InputDateNaissance.label"),
      name: "DATNAI"
    },
    SearchSITFAM: {
      Titre: t("FormClientPhysique.informationclient.SearchSITFAM.Titre"),
      label: t("FormClientPhysique.informationclient.SearchSITFAM.label"),
      name: "SITFAM", params: searchSituationFamiliale
    },
    SearchSIGestionnaire: {
      Titre: t("FormClientPhysique.informationclient.SearchGestionnaire.Titre"),
      label: t("FormClientPhysique.informationclient.SearchGestionnaire.label"),
      name: "CDGEST", params: searchGestionnaire
    },
    SearchProspect: {
      Titre: t("FormClientPhysique.informationclient.SearchProspect.Titre"),
      label: t("FormClientPhysique.informationclient.SearchProspect.label"),
      name: "codProspect", params: searchProspect
    },
    SearchClasseRisque: {
      Titre: t("FormClientPhysique.informationclient.SearchClasseRisque.Titre"),
      label: t("FormClientPhysique.informationclient.SearchClasseRisque.label"),
      name: "CLARIS", params: searchClassRisque
    },
    SearchNationalite: {
      Titre: t("FormClientPhysique.informationclient.SearchNationalite.Titre"),
      label: t("FormClientPhysique.informationclient.SearchNationalite.label"),
      name: "CDPAYS", params: searchPays
      //suspend
    },
    SearchActivite: {
      Titre: t("FormClientPhysique.informationclient.SearchActivite.Titre"),
      label: t("FormClientPhysique.informationclient.SearchActivite.label"),
      name: "CDENAE", params: searchActivite
    },
    SearchUniteI: {
      Titre: t("FormClientPhysique.informationclient.SearchUniteI.Titre"),
      label: t("FormClientPhysique.informationclient.SearchUniteI.label"),
      name: "CDENUI", params: searchUniteInstitutionnel
    },
    SearchPaysR: {
      Titre: t("FormClientPhysique.informationclient.SearchPaysR.Titre"),
      label: t("FormClientPhysique.informationclient.SearchPaysR.label"),
      name: "CDERES", params: searchPays
    },
    InputCleCli: {
      label: t("FormClientPhysique.informationclient.InputCleCli.label"),
      name: "CLECLI"
    },
    InputNom: {
      label: t("FormClientPhysique.informationclient.InputNom.label"),
      name: "NOMCLI"
    },
    InputPrenom: {
      label: t("FormClientPhysique.informationclient.InputPrenom.label"),
      name: "PRECLI"
    },
    RadioActionnaire: {
      label: t("FormClientPhysique.informationclient.RadioActionnaire.label"),
      LibValue1: t("FormClientPhysique.informationclient.RadioActionnaire.LibValue1"),
      LibValue2: t("FormClientPhysique.informationclient.RadioActionnaire.LibValue2"),
      name: "actionaire"
    },
    InputLieuNaissance: {
      label: t("FormClientPhysique.informationclient.InputLieuNaissance.label"),
      name: "LIENAI"
    },
    InputPieceIdentite: {
      label: t("FormClientPhysique.informationclient.InputPieceIdentite.label"),
      name: "numCNI"
    },
    InputExpiredate: {
      label: t("FormClientPhysique.informationclient.InputExpiredate.label"),
      name: "DateDelcni"
    },
    InputNIU: {
      label: t("FormClientPhysique.informationclient.InputNIU.label"),
      name: "NIU"
    },
    SearchRegimeMatrimonial: {
      Titre: t("FormClientPhysique.informationclient.SearchRegimeMatrimonial.Titre"),
      label: t("FormClientPhysique.informationclient.SearchRegimeMatrimonial.label"),
      name: "REGMAT", params: searchRegimeMatrimonial
    },
    SearchEthnie: {
      Titre: t("FormClientPhysique.informationclient.SearchEthnie.Titre"),
      label: t("FormClientPhysique.informationclient.SearchEthnie.label"),
      name: "ETHNIE", params: searchEthnie
    },
    SearchZoneGeo: {
      Titre: t("FormClientPhysique.informationclient.SearchZoneGeo.Titre"),
      label: t("FormClientPhysique.informationclient.SearchZoneGeo.label"),
      name: "RESIDE", params: searchZoneGeo
    }
  }
  
  // const oncheckD = (e: any) => {
    
  //   props.form.resetFields();
  //   props.form.setFieldValue("ValCli",e.target.value);
  //   if (e.target.value == 'O') 
  //   { 
  //     setSearchClient({CodeAgence: user.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE', Choix: 22 })
  //   }
  //   else if (e.target.value == 'N') 
  //   {
  //     setSearchClient({CodeAgence: user.codage, Table: "CLIENTTMP", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE', Choix: 22 })
  //   }
  // }


  return (
    <div className='tabItem' >
        <Box display={'flex'} className='border' width={"85%"} position={"absolute"} >
          <Box fontStyle="inherit" className='border-left' >
            <Grid container spacing={0}>
               <Grid item xs={12} sm={6} md={4}>
                 <SearchInput width={4} dissabledCode={props.etatG} notRequired form={props.form}  Titre={informationclient.SearchClient.Titre} label={informationclient.SearchClient.label} name={informationclient.SearchClient.name} Parametre={informationclient.SearchClient.params} />  
               </Grid>
               <Grid item xs={12} sm={6} md={4}>
                <RadioBox  label={informationclient.RadioActionnaire.label} name={informationclient.RadioActionnaire.name} Value1='O' Value2='N' LibValue1={informationclient.RadioActionnaire.LibValue1} libVlue2={informationclient.RadioActionnaire.LibValue2} />
               </Grid>
                <Grid item xs={12} sm={6} md={4}>
                <RadioBox etat={false}  label={informationclient.RadioDirigeantE.label} name={informationclient.RadioDirigeantE.name} Value1='O' Value2='N' LibValue1={informationclient.RadioDirigeantE.LibValue1} libVlue2={informationclient.RadioDirigeantE.LibValue2} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <SearInputM width={4} form={props.form}  Titre={informationclient.SearchTitre.Titre} label={informationclient.SearchTitre.label} name={informationclient.SearchTitre.name} Parametre={informationclient.SearchTitre.params} />
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                    <InputForm icon={<BoyIcon color='info'/>}  width={7} label={informationclient.InputNom.label} name={informationclient.InputNom.name} type='text' error='ce Champ est obligatoire' />

                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                 <InputForm icon={<AccessibilityNewIcon color='primary'/>} width={7} label={informationclient.InputPrenom.label} name={informationclient.InputPrenom.name} type='text' error='ce Champ est obligatoire' />

                </Grid>
                
                <Grid item xs={12} sm={6} md={4}>
                   <RadioBox  label={informationclient.RadioSexe.label} name={informationclient.RadioSexe.name} Value1='M' Value2='F' LibValue1={informationclient.RadioSexe.LibValue1} libVlue2={informationclient.RadioSexe.LibValue2} />
           
               </Grid>
                <Grid item xs={12} sm={6} md={4}>
                   <InputForm width={7}  onBlur={handleChangedatenais} icon={<PermContactCalendarIcon color='action'/>} label={informationclient.InputDateNaissance.label} name={informationclient.InputDateNaissance.name} type='date' error='obligation' />
                </Grid>
                   <Grid item xs={12} sm={6} md={4}>
             {/* <InputForm icon={<BoyIcon color='info'/>}  width={7} label={informationclient.InputNom.label} name={informationclient.InputNom.name} type='text' error='ce Champ est obligatoire' />
            <InputForm icon={<AccessibilityNewIcon color='primary'/>} width={7} label={informationclient.InputPrenom.label} name={informationclient.InputPrenom.name} type='text' error='ce Champ est obligatoire' /> */}
             <InputForm width={7} icon={<HouseboatIcon color='action'/>} label={informationclient.InputLieuNaissance.label} name={informationclient.InputLieuNaissance.name} type='text' error='ce Champ est obligatoire' />

               </Grid>
              
                <Grid item xs={12} sm={6} md={4}>
                   <SelectOption    icon={<BrandingWatermarkIcon color='action'/>} onchange={handleChangeTypiece} width={7} label="Type d'identification" name='TYPEPIECE' Size={'middle'} Parametre={searchTypePiece} />
               </Grid>
              <Grid item xs={12} sm={6} md={4}>
             <InputForm icon={<BadgeIcon color='action'/>} onBlur={()=>{handleTypieceVerifie()}}  RegExp={RPiece} width={7} label={informationclient.InputPieceIdentite.label} name={informationclient.InputPieceIdentite.name} type={TPiece} error='ce Champ est obligatoire' MessExp={MPiece} />

              </Grid>
              <Grid item xs={12} sm={6} md={4}>
              <InputForm width={7}  icon={<AutoModeIcon color='action'/>} label={informationclient.InputExpiredate.label} name={informationclient.InputExpiredate.name} type='date' error='ce Champ est obligatoire' onBlur={handleChangedateexpirecni} />

              </Grid>
               <Grid item xs={12} sm={6} md={4}>
                         <InputForm width={7} icon={<NoAccountsIcon color='action'/>} label={informationclient.InputNIU.label} name={informationclient.InputNIU.name} type='text' error='ce Champ est obligatoire' />

              </Grid>
              <Grid item xs={12} sm={6} md={4}>
               <SearInputM form={props.form} width={7}  Titre={informationclient.SearchNationalite.Titre} label={informationclient.SearchNationalite.label} name={informationclient.SearchNationalite.name} Parametre={informationclient.SearchNationalite.params} />
               </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <SearInputM form={props.form} width={7}  Titre={informationclient.SearchRegimeMatrimonial.Titre} label={informationclient.SearchRegimeMatrimonial.label} name={informationclient.SearchRegimeMatrimonial.name} Parametre={informationclient.SearchRegimeMatrimonial.params} />

               </Grid>
                <Grid item xs={12} sm={6} md={4}>
                 <SearInputM form={props.form} width={7}  Titre={informationclient.SearchSITFAM.Titre} label={informationclient.SearchSITFAM.label} name={informationclient.SearchSITFAM.name} Parametre={informationclient.SearchSITFAM.params} />

                </Grid>
              
                <Grid item xs={12} sm={6} md={4}>
                   <SearInputM form={props.form} width={7}  Titre={informationclient.SearchSIGestionnaire.Titre} label={informationclient.SearchSIGestionnaire.label} name={informationclient.SearchSIGestionnaire.name} Parametre={informationclient.SearchSIGestionnaire.params} />
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                 <SearInputM form={props.form} width={7}  Titre={informationclient.SearchProspect.Titre} label={informationclient.SearchProspect.label} name={informationclient.SearchProspect.name} Parametre={searchProspect} />

                 </Grid>
                 <Grid item xs={12} sm={6} md={4}>
               <SearInputM form={props.form} width={7}  Titre={informationclient.SearchClasseRisque.Titre} label={informationclient.SearchClasseRisque.label} name={informationclient.SearchClasseRisque.name} Parametre={informationclient.SearchClasseRisque.params} />

                 </Grid>
               
                <Grid item xs={12} sm={6} md={4}>
                <SearInputM form={props.form} width={7}  Titre={informationclient.SearchActivite.Titre} label={informationclient.SearchActivite.label} name={informationclient.SearchActivite.name} Parametre={informationclient.SearchActivite.params} />

                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                   <SearInputM form={props.form} width={7}  Titre={informationclient.SearchUniteI.Titre} label={informationclient.SearchUniteI.label} name={informationclient.SearchUniteI.name} Parametre={informationclient.SearchUniteI.params} />
                 </Grid>

               <Grid item xs={12} sm={6} md={4}>
                 <SearInputM form={props.form} width={7}  Titre={informationclient.SearchPaysR.Titre} label={informationclient.SearchPaysR.label} name={informationclient.SearchPaysR.name} Parametre={searchPays} />

                </Grid>
                
                <Grid item xs={12} sm={6} md={4}>
                  <SearInputM form={props.form} notRequired width={7}  Titre='Recherche Catégorié Socio Profetionnel' label='Catégorié Socio Prof' name='CATPRO' Parametre={searchCateGo} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                <SearInputM form={props.form} notRequired width={7}  Titre='Recherche Zone Géographique' label='Zone Géographique' name='RESIDE' Parametre={searchZoneGeo} />
               </Grid>
                
               
               <Grid item xs={12} sm={6} md={4}>
                 <SearInputM form={props.form} notRequired width={7}  Titre='Recherche Niveau instruction' label='Niveau instruction' name='INSTRU' Parametre={searchNiveauInstruction} />
 
               </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <SearInputM form={props.form} width={7}  Titre='Recherche Ethnie' label='Code Ethnie' name='ETHNIE' Parametre={searchEthnie} />
              </Grid>

            </Grid>
            {/* <RadioBox     disabled={false} width={7} label={"Client Validé"}  name={"ValCli"} Value1='O' Value2='N' defaultValue='O' LibValue1={"OUI"} libVlue2={"NON"} onchange={oncheckD} /> */}
           </Box>

          {/* <Box fontStyle="inherit" className='border-left' >
             
          </Box> */}

        </Box>
    </div>

  );
}

export default Tab1;